import Vue from 'vue'
import './styles/main.scss'
import Layout from './components/Layout.vue'

new Vue({
  el: '#app',
  render: h => h(Layout)
})



// WEBPACK FOOTER //
// ./src/main.js